import { BiSolidDashboard } from "react-icons/bi";
import { LuRoute } from "react-icons/lu";
import { GrPlan } from "react-icons/gr";
import { TbBuildingStore } from "react-icons/tb";
import { GiVendingMachine } from "react-icons/gi";
import { MdInventory2 } from "react-icons/md";
import { MdTaskAlt } from "react-icons/md";
import { HiOutlineDocumentReport } from "react-icons/hi";
import { IoIosSettings } from "react-icons/io";
import { MdReceiptLong } from "react-icons/md";
import { FiTrendingUp, FiMail, FiCalendar } from "react-icons/fi";
import { IconComponent } from "../icons";

export type NavItemKey =
  | "dashboard"
  | "routes"
  | "routePlanner"
  | "locations"
  | "machines"
  | "inventory"
  | "expenses"
  | "inbox"
  | "calendar"
  | "growth"
  | "tasks"
  | "reports"
  | "configurations"
  | "helpCenter";

export type NavItem = {
  key: NavItemKey;
  label: string;
  path: string;
  icon: IconComponent;
};

export const NAV_ITEMS: NavItem[] = [
  {
    key: "dashboard",
    label: "Dashboard",
    path: "/dashboard",
    icon: BiSolidDashboard as IconComponent,
  },
  {
    key: "routes",
    label: "Routes",
    path: "/routes",
    icon: LuRoute as IconComponent,
  },
  {
    key: "routePlanner",
    label: "Route Planner",
    path: "/route-planner",
    icon: GrPlan as IconComponent,
  },
  {
    key: "locations",
    label: "Locations",
    path: "/locations",
    icon: TbBuildingStore as IconComponent,
  },
  {
    key: "machines",
    label: "Machines",
    path: "/machines",
    icon: GiVendingMachine as IconComponent,
  },
  {
    key: "inventory",
    label: "Inventory",
    path: "/inventory",
    icon: MdInventory2 as IconComponent,
  },
  {
    key: "expenses",
    label: "Expenses",
    path: "/expenses",
    icon: MdReceiptLong as IconComponent,
  },
  {
    key: "growth",
    label: "Growth",
    path: "/growth",
    icon: FiTrendingUp as IconComponent,
  },
  {
    key: "tasks",
    label: "Tasks",
    path: "/tasks",
    icon: MdTaskAlt as IconComponent,
  },
  {
    key: "reports",
    label: "Reports",
    path: "/reports",
    icon: HiOutlineDocumentReport as IconComponent,
  },
  { key: "calendar", label: "Calendar", path: "/calendar", icon: FiCalendar as IconComponent },
  { key: "inbox", label: "Connect", path: "/inbox", icon: FiMail as IconComponent },
  {
    key: "configurations",
    label: "Configurations",
    path: "/configurations",
    icon: IoIosSettings as IconComponent,
  },
];
